/** カタログフォームの電話番号（非表示 / 任意 / 必須） */
export type CatalogTelFormState = 'hidden' | 'optional' | 'required'

/** カタログフォームの住所（非表示 / 都道府県のみ / 郵便番号〜番地まで必須） */
export type CatalogAddressFormState = 'hidden' | 'prefecture_only' | 'required'

export function normalizeCatalogTelFormState(value: unknown): CatalogTelFormState {
  if (value === null || value === undefined) return 'required'
  if (typeof value === 'number') {
    const map: Record<number, CatalogTelFormState> = {
      0: 'hidden',
      1: 'optional',
      2: 'required',
    }
    return map[value] ?? 'required'
  }
  if (typeof value === 'string') {
    if (value === 'hidden' || value === 'optional' || value === 'required') return value
    const n = parseInt(value, 10)
    if (!Number.isNaN(n)) return normalizeCatalogTelFormState(n)
  }
  return 'required'
}

/** 旧「任意」(optional) は廃止。API やキャッシュで残っていれば必須扱いに寄せる */
export function normalizeCatalogAddressFormState(value: unknown): CatalogAddressFormState {
  if (value === null || value === undefined) return 'required'
  if (typeof value === 'number') {
    const map: Record<number, CatalogAddressFormState> = {
      0: 'hidden',
      1: 'prefecture_only',
      2: 'required',
    }
    return map[value] ?? 'required'
  }
  if (typeof value === 'string') {
    if (value === 'hidden' || value === 'prefecture_only' || value === 'required') return value
    if (value === 'optional') return 'required'
    const n = parseInt(value, 10)
    if (!Number.isNaN(n)) return normalizeCatalogAddressFormState(n)
  }
  return 'required'
}

export function buildCatalogFormKeys(
  webFormTelState: CatalogTelFormState,
  webFormAddressState: CatalogAddressFormState
): string[] {
  const keys = ['name', 'name_kana', 'email']
  if (webFormTelState !== 'hidden') keys.push('tel')
  if (webFormAddressState === 'prefecture_only') {
    keys.push('prefecture_code')
  } else if (webFormAddressState !== 'hidden') {
    keys.push('zipcode', 'prefecture_code', 'city_name', 'address')
  }
  return keys
}

export function buildCatalogOptionalKeys(webFormTelState: CatalogTelFormState): string[] {
  const keys: string[] = []
  if (webFormTelState === 'optional') keys.push('tel')
  return keys
}
